interface StatisticCardProps {
  icon: string;
  value?: string;
  unit: string;
  description: string;
  iconWidth?: string;
  padding?: string;
  borderRadius?: string;
}

const StatisticCard = ({ icon, value, unit, description, iconWidth = "120px", padding = "p-9", borderRadius = "rounded-lg" }: StatisticCardProps) => {
  return (
    <div className={`flex flex-1 flex-col items-center ${padding} ${borderRadius} bg-[#f0f0f3] rounded-lg text-center`}>
      <img src={icon} alt={unit} style={{ maxWidth: iconWidth }} />
      <div className="text-2xl font-bold text-primary mt-9 mb-3">
        {value && <span className="text-4xl text-[#F39200]">{value}</span>} {unit}
      </div>
      <div className="text-sm text-primary">{description}</div>
    </div>
  );
};

export default StatisticCard; 